
(function () {

  const deliveryDaysMap = {
    "oneday": 1, "1 day": 1,
    "2 days": 2, "twodays": 2, "df_2days": 2,
    "3 day": 3, "3 days": 3, "threedays": 3, "delivery-3-days": 3,
    "10 days": 10, "tendays": 10, "df_14day": 10, "df_21day": 10,
    "23 days": 10, "df_23days": 10, "df_28days": 10,
    "delivery-2-weeks": 10, "delivery-2-4-weeks": 10,
    "df_35days": 30, "df_710days": 30, "delivery-4-6-weeks": 30,
    "df_34weeks": 30, "23 weeks": 30, "df_23weeks": 30,
    "df_45weeks": 30, "56 weeks": 30, "df_56weeks": 30, "df_68weeks": 30
  };

  const dayWordMap = {
    1: 'Next', 2: 'Two', 3: 'Three', 4: 'Four', 5: 'Five',
    6: 'Six', 7: 'Seven', 8: 'Eight', 9: 'Nine', 10: 'Ten', 30: 'Thirty'
  };

  function parseCutoffHM(str, defH = 15, defM = 0) {
    if (!str) return [defH, defM];
    const m = String(str).trim().match(/^(\d{1,2})(?::(\d{2}))?$/);
    return m ? [Number(m[1]), Number(m[2] || 0)] : [defH, defM];
  }

  function clampToMinute(ts = Date.now()) {
    return new Date(Math.floor(ts / 60000) * 60000);
  }

  function isBusinessDay(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  }

  function nextBusinessDay(fromDate) {
    const d = new Date(fromDate);
    while (!isBusinessDay(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function addBusinessDays(dispatchDate, businessDays) {
    let d = new Date(dispatchDate);
    let added = 0;
    while (added < businessDays) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) added++;
    }
    return d;
  }

  function computeDispatchAndDelivery(now, cutoffStr, businessDaysOffset) {
    const [cutH, cutM] = parseCutoffHM(cutoffStr || '15:00');
    const todayCutoff = new Date(now);
    todayCutoff.setHours(cutH, cutM, 0, 0);
    const pastCutoff = now >= todayCutoff;
    const candidate = new Date(now);
    if (pastCutoff) candidate.setDate(candidate.getDate() + 1);
    const dispatchDate = nextBusinessDay(candidate);
    const deliveryDate = addBusinessDays(dispatchDate, businessDaysOffset);
    const nextCutoff = new Date(todayCutoff);
    if (pastCutoff) nextCutoff.setDate(nextCutoff.getDate() + 1);
    const diffMs = nextCutoff - now;
    const cutoffHrs = Math.floor(diffMs / 36e5);
    const cutoffMins = Math.floor((diffMs % 36e5) / 6e4);
    return { dispatchDate, deliveryDate, cutoffHrs, cutoffMins };
  }

  function getDiffDays(now, deliveryDate) {
    const today = new Date(now);
    today.setHours(0, 0, 0, 0);
    const dm = new Date(deliveryDate);
    dm.setHours(0, 0, 0, 0);
    return (dm - today) / 86400000;
  }

  function initDeliveryTimers() {
    const now = clampToMinute();

    const timerDiv = document.getElementById('custom-delivery-timer');
    if (timerDiv) {
      const deliveryTag = (timerDiv.dataset.deliveryTag || 'oneday').toLowerCase();
      const cutoffStr = timerDiv.dataset.cutoffTime || '15:00';
      const priceMsg = timerDiv.dataset.priceClaimMessage || '';
      const baseOffset = deliveryDaysMap[deliveryTag] ?? 1;
      const { deliveryDate, cutoffHrs, cutoffMins } = computeDispatchAndDelivery(now, cutoffStr, baseOffset);
      const diffDays = getDiffDays(now, deliveryDate);
      const finalMsg = dayWordMap[baseOffset] ? `Free ${dayWordMap[baseOffset]} Day Delivery` : `Free ${baseOffset} Day Delivery`;
      const deliveryDay = diffDays === 1 ? 'Tomorrow' : deliveryDate.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' });
      timerDiv.innerHTML = `
        <div class="delivery-timer-msg">
          <strong>${finalMsg}</strong>
          <span class="delivery-price-msg">${priceMsg}</span>
        </div>
        <div id="delivery_timer_wrapper1">
          Order within the next
          <span class="countdown-text">${cutoffHrs} Hr${cutoffHrs !== 1 ? 's' : ''} ${cutoffMins} Min${cutoffMins !== 1 ? 's' : ''}</span>
          for delivery by <span class="countdown-text">${deliveryDay}</span>.
        </div>
      `;
    }

    document.querySelectorAll('.stock-delivery-timer-texts').forEach(el => {
      const deliveryTag = (el.dataset.deliveryTag || 'oneday').toLowerCase();
      const cutoffStr = el.dataset.cutoffTime || '15:00';
      const baseOffset = deliveryDaysMap[deliveryTag] ?? 1;
      const { deliveryDate } = computeDispatchAndDelivery(now, cutoffStr, baseOffset);
      const diffDays = getDiffDays(now, deliveryDate);
      let display;
      if (diffDays === 1) {
        display = `<span class="Date">Tomorrow</span>`;
      } else {
        const str = deliveryDate.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
        display = `<span class="Date">${str.replace(',', ' <span class="mobile-text Date">,')}</span></span>`;
      }
      el.innerHTML = `<span class="stock-available-text">In Stock</span><span> for Delivery By </span>${display}`;
    });

    document.querySelectorAll('.cart-item-est-delivery').forEach(el => {
      const deliveryTag = (el.dataset.deliveryTag || 'oneday').toLowerCase();
      const cutoffStr = el.dataset.cutoffTime || '15:00';
      const baseOffset = deliveryDaysMap[deliveryTag] ?? 1;
      const { deliveryDate } = computeDispatchAndDelivery(now, cutoffStr, baseOffset);
      const diffDays = getDiffDays(now, deliveryDate);
      let display;
      if (diffDays === 1) {
        display = 'Tomorrow';
      } else {
        const str = deliveryDate.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' });
        display = str.replace(',', ' <span class="mobile-text Date">,') + '</span>';
      }
      el.innerHTML = `<span class="Date">${display}</span>`;
    });
  }

  window.initDeliveryTimers = initDeliveryTimers;

  document.addEventListener('DOMContentLoaded', initDeliveryTimers);

  document.addEventListener('cart:updated', initDeliveryTimers);

  document.addEventListener('DOMContentLoaded', function () {
    const cartWrapper = document.querySelector('[data-cart-wrapper]');
    if (!cartWrapper) return;

    let debounceTimer;
    const observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(initDeliveryTimers, 150);
    });

    observer.observe(cartWrapper, {
      childList: true,
      subtree: true
    });
  });

})();